// @flow
// Externals
import React from "react";
import Lottie from "react-lottie-player";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
import animationData from "../../static/lottie/Q2.json";

const NUMBER = "2";

// Question Animation
/*::
type Props = {
}
*/
const Animation = (props /*: Props */) /*: any */ => (
	<div className="animation" data-cy={`div-animation-q${NUMBER}`}>
		<Lottie
			className="lottie-container basic"
			animationData={animationData}
			play={true}
			loop={true}
			speed={2.5}
		/>
	</div>
);

// Exports
export default Animation;
